import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectNewLicense = (state: StoreSchema) =>
    state.newLicenseState.newLicense
